import { render, staticRenderFns } from "./MassiveInfoCards.vue?vue&type=template&id=22e1d340&scoped=true"
import script from "./MassiveInfoCards.vue?vue&type=script&lang=js"
export * from "./MassiveInfoCards.vue?vue&type=script&lang=js"
import style0 from "./MassiveInfoCards.vue?vue&type=style&index=0&id=22e1d340&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e1d340",
  null
  
)

export default component.exports